import { render, staticRenderFns } from "./CategoryInput.vue?vue&type=template&id=86228c4c&scoped=true&"
import script from "./CategoryInput.vue?vue&type=script&lang=js&"
export * from "./CategoryInput.vue?vue&type=script&lang=js&"
import style0 from "./CategoryInput.vue?vue&type=style&index=0&id=86228c4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86228c4c",
  null
  
)

export default component.exports